import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { Sparkles, Heart, Leaf } from 'lucide-react';

const Product = () => {
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'hsl(30, 30%, 98%)' }}>
      <Navigation />

      {/* Hero Section */}
      <section className="relative py-12 sm:py-16 lg:py-20">
        <div className="absolute inset-0 overflow-hidden">
          <img
            src="https://storage.googleapis.com/fenado-ai-farm-public/generated/c82748a9-ac81-4d51-ad32-aaf7853f8f17.webp"
            alt="Natural Ingredients"
            className="w-full h-full object-cover opacity-20"
          />
        </div>
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6" style={{ fontFamily: 'Quicksand, sans-serif', color: 'hsl(345, 60%, 60%)', lineHeight: 1.4 }}>
            Our Product
          </h1>
          <p className="text-base sm:text-lg lg:text-xl leading-relaxed" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 20%, 20%)', lineHeight: 1.7 }}>
            Introducing a revolutionary Daily Beauty Cream designed specifically for Indian skin
          </p>
        </div>
      </section>

      {/* Product Showcase */}
      <section className="py-8 sm:py-12">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              {/* Product Image */}
              <div className="relative bg-gradient-to-br from-rose-50 to-green-50 p-8 sm:p-12 flex items-center justify-center">
                <div className="relative">
                  <img
                    src="https://storage.googleapis.com/fenado-ai-farm-public/generated/7ecc400e-cf7e-48ac-bccb-e44098d38d6c.webp"
                    alt="Moonlit Beauty Cream"
                    className="w-full h-auto max-w-sm rounded-lg shadow-xl"
                  />
                  {/* Coming Soon Overlay */}
                  <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-40 rounded-lg">
                    <div className="text-center p-6 bg-white bg-opacity-95 rounded-xl shadow-2xl">
                      <h3 className="text-3xl sm:text-4xl font-bold mb-2" style={{ fontFamily: 'Quicksand, sans-serif', color: 'hsl(345, 60%, 60%)' }}>
                        COMING SOON
                      </h3>
                      <p className="text-sm sm:text-base" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 20%, 20%)' }}>
                        Something beautiful is on its way
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Product Details */}
              <div className="p-8 sm:p-12">
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-6" style={{ fontFamily: 'Quicksand, sans-serif', color: 'hsl(345, 60%, 60%)' }}>
                  Moonlit Beauty Cream
                </h2>

                <p className="text-base sm:text-lg leading-relaxed mb-8" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 20%, 20%)', lineHeight: 1.7 }}>
                  For the first time, experience a daily beauty cream that doesn't just provide glow—it actively heals and benefits your skin with our unique formulation of beneficial ingredients.
                </p>

                {/* Features */}
                <div className="space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 p-3 rounded-lg" style={{ backgroundColor: 'hsl(345, 60%, 96%)' }}>
                      <Sparkles size={24} style={{ color: 'hsl(345, 60%, 60%)' }} />
                    </div>
                    <div>
                      <h3 className="text-lg font-bold mb-1" style={{ fontFamily: 'Quicksand, sans-serif', color: 'hsl(30, 20%, 20%)' }}>
                        Daily Glow
                      </h3>
                      <p className="text-sm sm:text-base" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 10%, 50%)', lineHeight: 1.7 }}>
                        Achieve natural radiance every day
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 p-3 rounded-lg" style={{ backgroundColor: 'hsl(140, 30%, 96%)' }}>
                      <Leaf size={24} style={{ color: 'hsl(140, 30%, 55%)' }} />
                    </div>
                    <div>
                      <h3 className="text-lg font-bold mb-1" style={{ fontFamily: 'Quicksand, sans-serif', color: 'hsl(30, 20%, 20%)' }}>
                        Beneficial Ingredients
                      </h3>
                      <p className="text-sm sm:text-base" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 10%, 50%)', lineHeight: 1.7 }}>
                        Unique formulation that heals your skin
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 p-3 rounded-lg" style={{ backgroundColor: 'hsl(10, 75%, 96%)' }}>
                      <Heart size={24} style={{ color: 'hsl(10, 75%, 60%)' }} />
                    </div>
                    <div>
                      <h3 className="text-lg font-bold mb-1" style={{ fontFamily: 'Quicksand, sans-serif', color: 'hsl(30, 20%, 20%)' }}>
                        Quality Product
                      </h3>
                      <p className="text-sm sm:text-base" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 10%, 50%)', lineHeight: 1.7 }}>
                        High-quality, great value for all
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Info */}
          <div className="mt-8 sm:mt-12 bg-white rounded-2xl shadow-sm p-6 sm:p-8 text-center">
            <p className="text-base sm:text-lg leading-relaxed mb-4" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 20%, 20%)', lineHeight: 1.7 }}>
              Moonlit Beauty Cream is being crafted with care and precision to bring you the best in daily skincare. Stay tuned for our launch!
            </p>
            <p className="text-sm sm:text-base font-semibold" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(345, 60%, 60%)' }}>
              Want to be the first to know? Contact us today!
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Product;
